import { useTranslations } from "next-intl";
import { cn } from "@/utils/cn";
import styles from "./ErrorMessage.module.scss";

interface Props {
  message?: string;
  tranKey?: string;
  tranParams?: Record<string, string | number>;
  className?: string;
}

const ErrorMessage: React.FC<Props> = ({ message, tranKey, tranParams, className }) => {
  const t = useTranslations();

  if (!message && !tranKey) {
    return null;
  }

  const displayMessage = tranKey
    ? t(tranKey, { ...(message ? { defaultValue: message } : {}), ...(tranParams ?? {}) })
    : message;

  if (!displayMessage) {
    return null;
  }

  return (
    <div className={cn(styles.container, className)}>
      <p className={styles.message}>{displayMessage}</p>
    </div>
  );
};

export { ErrorMessage };
